import { createStore, compose, applyMiddleware } from 'redux';
import { install } from 'redux-loop';
import LogRocket from 'logrocket';
import routerMiddleware from 'redux-ui-router/src/router-middleware';
import { rootReducer } from './reducers';
import * as ACTION_TYPES from './constants/actionTypes';

// const routerMiddleware = require('redux-ui-router/lib/router-middleware');

let store = null;

// Create a store
export const createAppStore = ($stateProvider) => {
  const enhancer = compose(
    install(),
    // eslint-disable-next-line no-underscore-dangle
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (v) => v,
    applyMiddleware(LogRocket.reduxMiddleware()),
    applyMiddleware(routerMiddleware($stateProvider.$get()))
    // applyMiddleware('ngUiRouterMiddleware'),
  );

  store = createStore(rootReducer, enhancer);
  // Start with an INIT action
  store.dispatch({ type: ACTION_TYPES.INIT });

  return store;
};

export const getStore = () => store;
